import { render, staticRenderFns } from "./OrdersActions.vue?vue&type=template&id=5b3cae70"
import script from "./OrdersActions.vue?vue&type=script&lang=js"
export * from "./OrdersActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports